import {isValid} from 'date-fns'
import {omitBy, isNaN} from 'lodash'
import {validate as validateUuid} from 'uuid'

interface ReservationDataQuery {
  startDate?: string
  partySize?: string
  reservationLocationId?: string
  experienceId?: string
}

export const getReservationDataQueryParamsValidation = (
  {startDate, partySize, reservationLocationId, experienceId}: ReservationDataQuery,
  allowEmpty = false,
) => {
  const isStartDateValid = startDate ? isValid(new Date(startDate)) : allowEmpty
  const isPartySizeValid = partySize ? !isNaN(partySize) : allowEmpty
  const isReservationLocationIdValid = reservationLocationId
    ? validateUuid(reservationLocationId)
    : allowEmpty

  const isExperienceIdValid = experienceId ? validateUuid(experienceId) : true

  return {
    startDate: isStartDateValid,
    partySize: isPartySizeValid,
    reservationLocationId: isReservationLocationIdValid,
    experienceId: isExperienceIdValid,
  }
}
export const validateReservationDataQueryParam = (query: ReservationDataQuery) => {
  const validationResult = getReservationDataQueryParamsValidation(query)

  return (
    validationResult.startDate &&
    validationResult.partySize &&
    validationResult.reservationLocationId &&
    validationResult.experienceId
  )
}

export const validateIdQueryParam = (id: string = '') => validateUuid(id)

export const getUrlParamsFromObject = (obj: Record<string, string>) =>
  new URLSearchParams(omitBy(obj, (p) => p === undefined)).toString()
